export const alert = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26 28H22V18H26M26 36H22V32H26M2 42H46L24 4L2 42Z" fill="#FFC507"/>
</svg>`;
